// G2 v5 reads legend options per channel — a top-level `position` is ignored.
export const BOTTOM_LEGEND = {
  color: { position: 'bottom', layout: { justifyContent: 'flex-start' } },
} as const;
